// Web Storage can throw on any access (blocked cookies, Safari private mode,
// quota). Auth flow flags treat that as "unset" rather than failing the flow.
const attempt = (fn, fallback) => {
  try {
    return fn();
  } catch {
    return fallback;
  }
};

// The area is looked up per call: merely reading globalThis.localStorage can throw.
const storageArea = (name) => ({
  get: (key) => attempt(() => globalThis[name].getItem(key), null),
  // Returns false when the value could not be stored.
  set: (key, value) =>
    attempt(() => {
      globalThis[name].setItem(key, value);
      return true;
    }, false),
  remove: (key) => attempt(() => globalThis[name].removeItem(key)),
});

export const authLocalStorage = storageArea("localStorage");
export const authSessionStorage = storageArea("sessionStorage");
